// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"15":"d0f0a03d","296":"48cf5d01","408":"b60326cf","509":"70df648a","766":"b17830ae","910":"35470959"}[chunkId] + ".css";
};